import React from "react";
import Hero from "./Hero";
import ServicesComponent from "./ServicesComponent";
import CorporateObjectives from "./CoporateObjective";
import IsoCertification from "./IsoCertification";
import ProjectGallery from "./ProjectGallery";
import ForeignPartnerCarousel from "./ForeignPartnerCarousel";
import ClientsCarousel from "./ClientsCarousel";

const LandingPage = ()=>{

    return(
        <div>
            <Hero/>
            <ServicesComponent/>
            <CorporateObjectives/>
            <IsoCertification/>
            <ProjectGallery/>
            <ClientsCarousel/>
            <ForeignPartnerCarousel/>
        </div>
    )

}

export default LandingPage